// extracted by mini-css-extract-plugin
export default {"container":"PayinTermsOfUsePage_container_xQAmJ","viewer":"PayinTermsOfUsePage_viewer_B3un6","bottom":"PayinTermsOfUsePage_bottom_Lr78b"};